const ChatHeader = ({
    t,
    viewDensity,
    setViewDensity,
    onToggleMobileSidebar,
}) => {
    return (
        <div className="flex justify-between items-center pb-4">
            <div className="flex items-center gap-3">
                {onToggleMobileSidebar && (
                    <button
                        type="button"
                        onClick={onToggleMobileSidebar}
                        className="lg:hidden p-2 rounded-xl bg-white/60 border border-white/70 backdrop-blur
                        shadow-sm text-slate-600 hover:bg-white/80"
                        aria-label="Toggle sessions"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                )}
                <div>
                    <h1 className="lg:text-2xl text-xl font-semibold capitalize text-slate-900 flex">
                        Aura
                    </h1>
                    <p className="text-slate-500 text-sm capitalize">
                        {t("customer profile")} / Aura
                    </p>
                </div>
            </div>

            <div className="flex items-center gap-2 text-[11px] text-slate-600">
                <button
                    type="button"
                    className="rounded-full px-4 py-1.5 border border-white/70 bg-white/60 backdrop-blur
                    shadow-[0_12px_30px_rgba(15,23,42,0.08)] hover:bg-white/75"
                    onClick={() =>
                        setViewDensity((prev) =>
                            prev === "comfortable" ? "compact" : "comfortable"
                        )
                    }
                >
                    {viewDensity === "comfortable" ? t('aura header compact') : t('aura header comfort')}
                </button>
            </div>
        </div>
    );
};

export default ChatHeader;
